import { Box, Grid, Typography } from '@mui/material';
import { portalDashboardCardSx } from '../../../styles/portalSurfaces';
import { ArrowCircleUpIcon } from '../Styles/arrows';
import { formatCountOfTotal, normalizeMetric } from '../utils/metricFormatters';

const FUNNEL_CARDS = [
  {
    key: 'installToApplicationRate',
    title: 'Install -> Application Rate',
    subtitleSuffix: 'in selected period',
  },
  {
    key: 'applicationToApprovalRate',
    title: 'Application -> Approval Rate',
    subtitleSuffix: 'in selected period',
  },
  {
    key: 'approvalToPaymentRate',
    title: 'Approval -> Payment Rate',
    subtitleSuffix: 'in selected period',
  },
  {
    key: 'paymentToFirstBookingRate',
    title: 'Payment -> First Booking (Activation)',
    subtitleSuffix: 'within 14 days of paying',
  },
  {
    key: 'approvedUserD7Retention',
    title: 'Approved-User D7 Retention',
    subtitleSuffix: 'measured from approval',
  },
  {
    key: 'subscriberD7Retention',
    title: 'Subscriber D7 Retention',
    subtitleSuffix: 'paying members',
  },
  {
    key: 'subscriberD30Retention',
    title: 'Subscriber D30 Retention',
    subtitleSuffix: 'paying members',
  },
];

const POSITIVE_COLOR = '#34a853';

const formatApiPercent = (value) => {
  const n = Number(value);
  if (!Number.isFinite(n)) return '0%';
  if (Number.isInteger(n)) return `${n}%`;
  return `${parseFloat(n.toFixed(1))}%`;
};

const FunnelMetricCard = ({ title, percentage, count, totalCount, subtitleSuffix }) => {
  const percentageText = formatApiPercent(percentage);
  const body2Text = `${formatCountOfTotal(count, totalCount)} ${subtitleSuffix}`;

  return (
    <Box sx={{ p: 1.5, height: '100%', display: 'flex', flexDirection: 'column' }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
        <Typography variant="subtitle1" component="h2" sx={{ fontWeight: 'medium' }}>
          {title}
        </Typography>
      </Box>

      <Box sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
        <Typography variant="h4" component="span" sx={{ color: POSITIVE_COLOR }}>
          {percentageText}
        </Typography>

        <Typography
          variant="body2"
          sx={{ color: POSITIVE_COLOR, display: 'flex', alignItems: 'center' }}
        >
          <ArrowCircleUpIcon sx={{ fontSize: 20, mr: 0.5 }} />
          {body2Text}
        </Typography>
      </Box>
    </Box>
  );
};

const VettedCommunityFunnel = ({ metrics }) => {
  const funnel = metrics?.vettedCommunityFunnel ?? {};

  return (
    <Box sx={{ mt: 1, width: '100%' }}>
      <Box sx={{ mb: 2 }}>
        <Typography
          variant="h6"
          sx={{
            fontWeight: 'bold',
            color: (theme) => theme.palette.text.secondary,
          }}
        >
          Vetted Community Funnel
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
          Added to reflect the AI vetting/application flow — sits alongside the existing sections
          above, doesn&apos;t replace them.
        </Typography>
      </Box>

      <Grid container spacing={3}>
        {FUNNEL_CARDS.map((card) => {
          const stat = normalizeMetric(funnel[card.key]) || {
            count: 0,
            totalCount: 0,
            percentage: 0,
          };

          return (
            <Grid item xs={12} sm={6} md={4} key={card.key}>
              <Box sx={{ ...portalDashboardCardSx, minHeight: 140 }}>
                <FunnelMetricCard
                  title={card.title}
                  percentage={stat.percentage}
                  count={stat.count}
                  totalCount={stat.totalCount}
                  subtitleSuffix={card.subtitleSuffix}
                />
              </Box>
            </Grid>
          );
        })}
      </Grid>
    </Box>
  );
};

export default VettedCommunityFunnel;
